import { render, staticRenderFns } from "./DictionaryAcceptanceWordsEdit.vue?vue&type=template&id=2317ae14&"
import script from "./DictionaryAcceptanceWordsEdit.vue?vue&type=script&lang=js&"
export * from "./DictionaryAcceptanceWordsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports